import { Component } from '@angular/core';
import { HeroComponent } from './hero/hero.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { SocialsComponent } from './socials/socials.component';
import { AtrizultMapComponent } from "./atrizult-map/atrizult-map.component";

@Component({
  selector: 'app-contact-us',
  imports: [HeroComponent, ContactFormComponent, SocialsComponent, AtrizultMapComponent],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {

}
